/**
 * The decoded image when the browser already holds `src`, else null. A cache hit
 * is complete the moment `src` is set, so a cover can render without its blur.
 */
export function readCachedImage(src: string): HTMLImageElement | null {
	if (typeof Image === "undefined") return null
	const image = new Image()
	image.src = src
	return image.complete && image.naturalWidth > 0 ? image : null
}
